<template>
    <div class="loading-card flex-1">
        <div class="card__image"></div>
        <div class="card__content">
            <h2></h2>
            <p></p>
        </div>
    </div>
</template>